require('../../modules/es.map');
require('../../modules/esnext.map.upsert');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Map', 'upsert');
